import { createStore, combineReducers } from 'redux'
import localForage from 'localforage';

var dataStateReducer = (state = {}, action) => {
  switch (action.type.toLowerCase()) {
    case 'data':
      return Object.assign({}, state, {
        [action.key]: action.value
      })
    default:
      return state
  }
}

var setupStateReducer = (state = {}, action) => {
  switch (action.type.toLowerCase()) {
    case 'setup':
      return Object.assign({}, state, {
        [action.key]: action.value
      })
    default:
      return state
  }
}

const stateReducer = combineReducers({
  data: dataStateReducer,
  setup: setupStateReducer,
})

let storeInstance = null;

export default class Storage {

  static getStore() {
    if(!storeInstance){
      storeInstance = createStore(stateReducer);
    }
    return storeInstance;
  }

  //Data
  static setData(key, data) {
    localForage.setItem(`thesdg-client:data:${key}`, data || null);
    this.getStore().dispatch({
      type: 'data',
      key: key,
      value: data,
    });
  }

  static getData(key) {
    return this.getStore().getState()['data'][key];
  }

  static async loadData(key) {
    try {
      const data = await localForage.getItem(`thesdg-client:data:${key}`);
      this.getStore().dispatch({
        type: 'data',
        key: key,
        value: data,
      });
      return data;
    } catch (ex) {
      return null
    }
  }

  // Setup
  static setSetup(key, value) {
    this.getStore().dispatch({type: 'setup', key, value});
  }
  static getSetup(key) {
    return this.getStore().getState()['setup'][key];
  }
  
}
